module.exports = __webpack_public_path__ + "static/media/about.2471755d.png";